import { CoverageType } from 'apollo/types';

export const insuranceFrecequencyValues = [
  {
    value: '12',
    label: 'Anual (12 meses)',
  },
  {
    value: '24',
    label: 'Bienal (24 meses)',
  },
];

export const coverageTypeValues = [
  {
    value: CoverageType.Estandar,
    label: CoverageType.Estandar,
  },
  {
    value: CoverageType.Light,
    label: CoverageType.Light,
  },
  {
    value: CoverageType.Full,
    label: CoverageType.Full,
  },
  {
    value: CoverageType.Premium,
    label: CoverageType.Premium,
  },
  {
    value: CoverageType.AltaGama,
    label: 'Alta Gama',
  },
];

export const deducibleValues = [
  {
    value: '0',
    label: '0 UF',
  },
  {
    value: '3',
    label: '3 UF',
  },
  {
    value: '5',
    label: '5 UF',
  },
  {
    value: '7',
    label: '7 UF',
  },
  {
    value: '10',
    label: '10 UF',
  },
  {
    value: '15',
    label: '15 UF',
  },
  {
    value: '20',
    label: '20 UF',
  },
  {
    value: '30',
    label: '30 UF',
  },
];
